import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const filtersSection = css`
  display: flex;
  margin-bottom: 10px;

  > *:not(:first-child) {
    margin-left: 10px;
  }

  > *:last-child {
    margin-left: 30px;
  }
`;

export const filterOverlay = css`
  width: 320px;
`;

export const chipsWrapper = css`
  display: inline-flex;
  gap: 10px;
  margin: 0 0 10px;
  flex-wrap: wrap;
  align-items: center;
`;

const square = css`
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  margin: 0px 5px;
  background: ${colors.gray.default};
`;

export const severityLegend = css`
  align-self: center;

  > span {
    color: ${colors.gray.dark};
    margin-left: 20px;

    &:nth-child(2) {
      &:before {
        ${square}
        background: ${colors.warning.default};
      }
    }
    &:nth-child(3) {
      &:before {
        ${square}
        background: ${colors.error.default};
      }
    }
    &:nth-child(4) {
      &:before {
        ${square}
        background: ${colors.error.hover};
      }
    }
  }
`;
